import React, { Component } from 'react';
import lodash from 'lodash';
import { Link as NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import {
  Typography,
  Button,
  SvgIcon,
  Dialog,
  DialogContent,
  TextField,
  List,
  ListItem,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import { Search, Check } from '@material-ui/icons';

import {
  UPDATE_USER_REQUESTED,
  UPDATE_USER_SUCCESSFULL,
  UPDATE_USER_ERRORED
} from '../../../redux/actions/types';
import { updateUser } from '../../../redux/actions/auth';
import { fetchBrands } from '../../../redux/actions/categories';
import AdornedButton from '../../../commons/AdornedButton';
import { ReactComponent as PlusIcon } from '../../../images/Icons/plus.svg';
import { ReactComponent as CloseIcon } from '../../../images/Icons/x-circle.svg';
import normalizeString from '../../../utils/normalizeString';

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  brandsList: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  brandButton: {
    backgroundColor: '#ebebeb',
    margin: theme.spacing(1),
    color: '#707070',
    fontWeight: 400,
    '& > *': {
      fontSize: '1.1rem'
    }
  },
  addBrand: {
    margin: theme.spacing(1),
    minHeight: '42px',
    minWidth: '42px',
    maxWidth: '42px',
    fontWeight: 400,
    '& > *': {
      fontSize: '1.1rem'
    }
  },
  dialogContent: {
    minWidth: '400px',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
      width: '100%'
    }
  },
  list: {
    minHeight: '400px',
    maxHeight: '400px',
    overflowY: 'auto',
    width: '100%',
    '& > li': {
      cursor: 'pointer',
      textAlign: 'center',
      justifyContent: 'center'
    }
  },
  input: {
    fontSize: '0.9rem'
  },
  selected: {
    color: theme.palette.primary.main
  },
  closeIcon: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1)
  }
});

class Brands extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newSelection: props.user.brands,
      selectedBrands: props.user.brands,
      brands: props.brands || [],
      addingNewBrands: false,
      showingAll: props.user.brands.length <= 10,
      loading: false,
      searchBrand: ''
    };
  }

  componentDidMount() {
    if (this.props.editable) {
      this.props.fetchBrands();
    }
  }

  componentDidUpdate(prevProps) {
    if (!lodash.isEqual(prevProps.brands, this.props.brands)) {
      this.setState({ brands: this.props.brands });
    }

    if (!lodash.isEqual(prevProps.editable, this.props.editable)) {
      if (this.props.editable && this.state.brands.length === 0) {
        this.props.fetchBrands();
      }
    }

    if (prevProps.userStatus !== this.props.userStatus) {
      if (
        this.props.userStatus === UPDATE_USER_REQUESTED &&
        this.props.userChanges.includes('brands')
      ) {
        this.setState({
          loading: true
        });
      }
      if (
        this.props.userStatus === UPDATE_USER_SUCCESSFULL &&
        this.props.userChanges.includes('brands')
      ) {
        this.setState(state => ({
          loading: false,
          addingNewBrands: false,
          selectedBrands: state.newSelection
        }));
      }
      if (
        this.props.userStatus === UPDATE_USER_ERRORED &&
        this.props.userChanges.includes('brands')
      ) {
        this.setState({
          loading: false
        });
      }
    }
  }

  handleAddBrand = () => {
    this.setState(state => ({
      ...state,
      newSelection: state.selectedBrands,
      addingNewBrands: true
    }));
  };

  handleClose = () => {
    this.setState({
      addingNewBrands: false
    });
  };

  handleSave = () => {
    this.props.updateUser(this.state.newSelection.map(b => b.id));
  };

  handleSelectBrand = brand => {
    if (this.state.loading) {
      return;
    }
    if (this.state.newSelection.find(b => b.id === brand.id)) {
      this.setState(state => ({
        ...state,
        newSelection: state.newSelection.filter(b => b.id !== brand.id)
      }));
      return;
    }
    this.setState(state => ({
      ...state,
      newSelection: [...state.newSelection, brand]
    }));
  };

  handleSearchChange = ({ target: { value } }) => {
    this.setState({ searchBrand: value });
  };

  toggleShow = () => {
    this.setState(state => ({
      ...state,
      showingAll: !state.showingAll
    }));
  };

  render() {
    const { classes } = this.props;

    const filterFunction =
      this.state.searchBrand.trim() === ''
        ? () => true
        : b =>
            b.name
              .toUpperCase()
              .includes(this.state.searchBrand.trim().toUpperCase());

    return (
      <>
        <Dialog
          fullScreen={this.props.width === 'xs' || this.props.width === 'sm'}
          open={this.state.addingNewBrands}
          onClose={this.handleClose}
        >
          <DialogContent>
            <IconButton
              className={classes.closeIcon}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>
            <div className={classes.dialogContent}>
              <Typography color="primary" variant="h5">
                Mis marcas preferidas
              </Typography>
              <TextField
                fullWidth
                placeholder="Buscar marca"
                variant="outlined"
                type="text"
                value={this.state.searchBrand}
                onChange={this.handleSearchChange}
                InputProps={{
                  classes: {
                    input: classes.input
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />
              <List className={classes.list}>
                {this.state.brands.filter(filterFunction).map(brand => (
                  <ListItem
                    key={brand.id}
                    divider
                    onClick={() => this.handleSelectBrand(brand)}
                    className={`
                        ${
                          this.state.newSelection.find(b => b.id === brand.id)
                            ? classes.selected
                            : ''
                        }
                        item
                      `}
                  >
                    {this.state.newSelection.find(b => b.id === brand.id) && (
                      <Check color="primary" />
                    )}
                    {brand.name}
                  </ListItem>
                ))}
              </List>
              <AdornedButton
                loading={this.state.loading}
                disabled={this.state.loading}
                variant="contained"
                color="primary"
                onClick={this.handleSave}
              >
                OK
              </AdornedButton>
            </div>
          </DialogContent>
        </Dialog>
        <div className={classes.root}>
          <Typography style={{ fontSize: '1.2rem', fontWeight: 600 }}>
            Mis marcas favoritas
          </Typography>
          <div className={classes.brandsList}>
            {this.props.editable && (
              <Button
                variant="contained"
                color="primary"
                className={classes.addBrand}
                onClick={this.handleAddBrand}
              >
                <SvgIcon>
                  <PlusIcon />
                </SvgIcon>
              </Button>
            )}
            {this.state.selectedBrands
              .slice(
                0,
                this.state.showingAll ? this.state.selectedBrands.length : 10
              )
              .map(brand => (
                <Button
                  key={brand.id}
                  variant="contained"
                  className={classes.brandButton}
                  component={NavLink}
                  to={`/productos/marca/${normalizeString(brand.name)}`}
                >
                  {brand.name}
                </Button>
              ))}
            {this.state.selectedBrands.length > 10 && (
              <Typography
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  margin: '8px'
                }}
                onClick={this.toggleShow}
              >
                {this.state.showingAll ? 'Ver menos...' : 'Ver más...'}
              </Typography>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  brands: state.categories.brands,
  brandsStatus: state.categories.status,
  userStatus: state.auth.status,
  userChanges: state.auth.userChanges
});

const mapDispatchToProps = dispatch => ({
  updateUser: brands => dispatch(updateUser({ brands })),
  fetchBrands: () => dispatch(fetchBrands())
});

export default withStyles(styles)(
  withWidth()(connect(mapStateToProps, mapDispatchToProps)(Brands))
);
